// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_asrt_apply = require("./MM_asrt_apply.bs.js");
var MM_proof_tree = require("./MM_proof_tree.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var MM_substitution = require("./MM_substitution.bs.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_MutableMapInt = require("rescript/lib/js/belt_MutableMapInt.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function bottomUpProverParamsMake(asrtLabel, maxSearchDepthOpt, lengthRestrictOpt, allowNewDisjForExistingVarsOpt, allowNewStmtsOpt, allowNewVarsOpt, args0Opt, args1Opt, maxNumberOfBranches, param) {
  var maxSearchDepth = maxSearchDepthOpt !== undefined ? maxSearchDepthOpt : 4;
  var lengthRestrict = lengthRestrictOpt !== undefined ? lengthRestrictOpt : /* Less */2;
  var allowNewDisjForExistingVars = allowNewDisjForExistingVarsOpt !== undefined ? allowNewDisjForExistingVarsOpt : true;
  var allowNewStmts = allowNewStmtsOpt !== undefined ? allowNewStmtsOpt : true;
  var allowNewVars = allowNewVarsOpt !== undefined ? allowNewVarsOpt : true;
  var args0 = args0Opt !== undefined ? args0Opt : [];
  var args1 = args1Opt !== undefined ? args1Opt : [];
  return {
          asrtLabel: asrtLabel,
          maxSearchDepth: maxSearchDepth,
          lengthRestrict: lengthRestrict,
          allowNewDisjForExistingVars: allowNewDisjForExistingVars,
          allowNewStmts: allowNewStmts,
          allowNewVars: allowNewVars,
          args0: args0,
          args1: args1,
          maxNumberOfBranches: maxNumberOfBranches
        };
}

function findNonAsrtParent(tree, expr) {
  if (MM_proof_tree.ptIsNewVarDef(tree, expr)) {
    return /* VarType */0;
  }
  var hyp = MM_proof_tree.ptGetHypByExpr(tree, expr);
  if (hyp !== undefined) {
    return {
            TAG: /* Hypothesis */0,
            label: hyp.label
          };
  }
  
}

function findAsrtParentsWithoutNewVars(tree, expr, restrictExprLen) {
  var exprLen = expr.length;
  var foundParents = [];
  Belt_MapString.forEach(MM_proof_tree.ptGetFrms(tree), (function (param, frm) {
          var frmExpr = frm.frame.asrt;
          if (Caml_array.get(frmExpr, 0) === Caml_array.get(expr, 0)) {
            MM_substitution.iterateSubstitutions(frmExpr, expr, Caml_array.get(frm.frmConstParts, frm.numOfHypsE), Caml_array.get(frm.constParts, frm.numOfHypsE), Caml_array.get(frm.varGroups, frm.numOfHypsE), frm.subs, MM_proof_tree.ptGetParenCnt(tree), (function (subs) {
                    if (subs.isDefined.every(function (b) {
                            return b;
                          }) && Belt_Option.isNone(MM_substitution.verifyDisjoints(frm.frame.disj, subs, (function (param, param$1) {
                                  return MM_proof_tree.ptIsDisj(tree, param, param$1);
                                }), 0))) {
                      var hyps = frm.frame.hyps;
                      var numOfArgs = hyps.length;
                      var args = new Array(numOfArgs);
                      var argsAreCorrect = true;
                      var argIdx = 0;
                      var maxArgIdx = numOfArgs - 1 | 0;
                      while(argIdx <= maxArgIdx && argsAreCorrect) {
                        var newExpr = MM_substitution.applySubs(Caml_array.get(hyps, argIdx).expr, subs, (function (param) {
                                throw {
                                      RE_EXN_ID: MM_parser.MmException,
                                      _1: {
                                        msg: "Work variables are not supported in findAsrtParentsWithoutNewVars()."
                                      },
                                      Error: new Error()
                                    };
                              }));
                        var tmp;
                        switch (restrictExprLen) {
                          case /* No */0 :
                              tmp = true;
                              break;
                          case /* LessEq */1 :
                              tmp = newExpr.length <= exprLen;
                              break;
                          case /* Less */2 :
                              tmp = newExpr.length < exprLen;
                              break;
                          
                        }
                        argsAreCorrect = tmp;
                        if (argsAreCorrect) {
                          Caml_array.set(args, argIdx, MM_proof_tree.ptGetNode(tree, newExpr));
                        }
                        argIdx = argIdx + 1 | 0;
                      };
                      if (argsAreCorrect) {
                        foundParents.push({
                              TAG: /* Assertion */1,
                              args: args,
                              frame: frm.frame
                            });
                      }
                      
                    }
                    return /* Continue */0;
                  }));
            return ;
          }
          
        }));
  return foundParents;
}

function proveFloating(tree, node) {
  if (!(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && !MM_proof_tree.pnIsInvalidFloating(node))) {
    return ;
  }
  var nodesToCreateParentsFor = Belt_MutableQueue.make(undefined);
  var savedNodes = Belt_HashSet.make(16, MM_context.ExprHash);
  var saveNodeToCreateParentsFor = function (node) {
    var match = MM_proof_tree.pnGetProof(node);
    if (match !== undefined || Belt_HashSet.has(savedNodes, MM_proof_tree.pnGetExpr(node))) {
      return ;
    } else {
      Belt_HashSet.add(savedNodes, MM_proof_tree.pnGetExpr(node));
      return Belt_MutableQueue.add(nodesToCreateParentsFor, node);
    }
  };
  var saveArgs = function (src) {
    if (typeof src === "number") {
      return ;
    }
    if (src.TAG !== /* Assertion */1) {
      return ;
    }
    src.args.forEach(saveNodeToCreateParentsFor);
  };
  saveNodeToCreateParentsFor(node);
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && !Belt_MutableQueue.isEmpty(nodesToCreateParentsFor)) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(curNode))) {
      var fParents = MM_proof_tree.pnGetFParents(curNode);
      if (fParents !== undefined) {
        fParents.forEach(saveArgs);
      } else {
        var curExpr = MM_proof_tree.pnGetExpr(curNode);
        var parent = findNonAsrtParent(tree, curExpr);
        if (parent !== undefined) {
          MM_proof_tree.pnAddParent(curNode, parent, false);
        } else {
          findAsrtParentsWithoutNewVars(tree, curExpr, /* LessEq */1).forEach((function(curNode){
              return function (parent) {
                MM_proof_tree.pnAddParent(curNode, parent, false);
                saveArgs(parent);
              }
              }(curNode)));
        }
      }
    }
    
  };
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    return MM_proof_tree.pnSetInvalidFloating(node);
  }
  
}

function findAsrtParentsWithNewVars(tree, expr, args, exactOrderOfArgs, asrtLabel, allowEmptyArgs, allowNewVars, allowNewDisjForExistingVars, debugLevelOpt, maxNumberOfResults, onProgress, param) {
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var applResults = [];
  var restrictFoundCnt = Belt_Option.isSome(maxNumberOfResults);
  var maxFoundCnt = Belt_Option.getWithDefault(maxNumberOfResults, 0);
  var frameFilter = asrtLabel !== undefined ? (function (frame) {
        return frame.label === asrtLabel;
      }) : (function (param) {
        return true;
      });
  var maxVarBeforeSearch = MM_proof_tree.ptGetMaxVar(tree);
  MM_asrt_apply.applyAssertions(maxVarBeforeSearch, MM_proof_tree.ptGetFrms(tree), (function (param, param$1) {
          return MM_proof_tree.ptIsDisj(tree, param, param$1);
        }), args, exactOrderOfArgs, allowEmptyArgs, allowNewVars, expr, MM_proof_tree.ptGetParenCnt(tree), frameFilter, allowNewDisjForExistingVars, (function (res) {
          applResults.push(res);
          var foundCnt = applResults.length;
          if (onProgress !== undefined && foundCnt % 100 === 0) {
            Curry._1(onProgress, foundCnt);
          }
          if (restrictFoundCnt && foundCnt >= maxFoundCnt) {
            return /* Stop */1;
          } else {
            return /* Continue */0;
          }
        }), debugLevel, undefined, undefined);
  var foundParents = [];
  applResults.forEach(function (applResult) {
        var frm = Belt_MapString.get(MM_proof_tree.ptGetFrms(tree), applResult.asrtLabel);
        var frame;
        if (frm !== undefined) {
          frame = frm.frame;
        } else {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot find an assertion with label " + applResult.asrtLabel + " in findAsrtParentsWithNewVars."
                },
                Error: new Error()
              };
        }
        var match = applResult.err;
        var exit = 0;
        if (match !== undefined && typeof match !== "number") {
          switch (match.TAG | 0) {
            case /* NoUnifForAsrt */3 :
            case /* NoUnifForArg */4 :
            case /* NewVarsAreDisabled */5 :
                exit = 1;
                break;
            default:
              exit = 2;
          }
        } else {
          exit = 2;
        }
        switch (exit) {
          case 1 :
              if (debugLevel !== 0) {
                foundParents.push({
                      TAG: /* AssertionWithErr */2,
                      args: [],
                      frame: frame,
                      err: Belt_Option.getExn(applResult.err)
                    });
                return ;
              } else {
                return ;
              }
          case 2 :
              var applNewVarToTreeNewVar = Belt_MutableMapInt.make(undefined);
              applResult.newVars.forEach(function (applResNewVar, i) {
                    var newVarType = Caml_array.get(applResult.newVarTypes, i);
                    var treeNewVar = MM_proof_tree.ptAddNewVar(tree, newVarType);
                    Belt_MutableMapInt.set(applNewVarToTreeNewVar, applResNewVar, treeNewVar);
                  });
              MM_context.disjForEach(applResult.newDisj, (function (n, m) {
                      MM_proof_tree.ptAddDisjPair(tree, Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, n, n), Belt_MutableMapInt.getWithDefault(applNewVarToTreeNewVar, m, m));
                    }));
              var numOfArgs = frame.hyps.length;
              var args = new Array(numOfArgs);
              var unprovedFloating;
              var argIdx = 0;
              var maxArgIdx = numOfArgs - 1 | 0;
              while(argIdx <= maxArgIdx && (Belt_Option.isNone(unprovedFloating) || debugLevel !== 0)) {
                var argExpr = MM_substitution.applySubs(Caml_array.get(frame.hyps, argIdx).expr, applResult.subs, (function (param) {
                        throw {
                              RE_EXN_ID: MM_parser.MmException,
                              _1: {
                                msg: "New work variables are not expected here [findAsrtParentsWithNewVars]."
                              },
                              Error: new Error()
                            };
                      }));
                var maxI = argExpr.length - 1 | 0;
                for(var i = 0; i <= maxI; ++i){
                  var sym = Caml_array.get(argExpr, i);
                  if (sym > maxVarBeforeSearch) {
                    var treeVar = Belt_MutableMapInt.get(applNewVarToTreeNewVar, sym);
                    var tmp;
                    if (treeVar !== undefined) {
                      tmp = treeVar;
                    } else {
                      throw {
                            RE_EXN_ID: MM_parser.MmException,
                            _1: {
                              msg: "Could not replace an applVar with a treeVar."
                            },
                            Error: new Error()
                          };
                    }
                    Caml_array.set(argExpr, i, tmp);
                  }
                  
                }
                var argNode = MM_proof_tree.ptGetNode(tree, argExpr);
                Caml_array.set(args, argIdx, argNode);
                if (Caml_array.get(frame.hyps, argIdx).typ === /* F */0 && Belt_Option.isNone(applResult.err) && Belt_Option.isNone(unprovedFloating)) {
                  proveFloating(tree, argNode);
                  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(argNode))) {
                    unprovedFloating = MM_proof_tree.pnGetExpr(argNode);
                  }
                  
                }
                argIdx = argIdx + 1 | 0;
              };
              var match$1 = applResult.err;
              var err = match$1 !== undefined ? applResult.err : Belt_Option.map(unprovedFloating, (function (expr) {
                        return {
                                TAG: /* UnprovedFloating */2,
                                expr: expr
                              };
                      }));
              if (err !== undefined) {
                if (debugLevel !== 0) {
                  foundParents.push({
                        TAG: /* AssertionWithErr */2,
                        args: args,
                        frame: frame,
                        err: err
                      });
                  return ;
                } else {
                  return ;
                }
              } else {
                foundParents.push({
                      TAG: /* Assertion */1,
                      args: args,
                      frame: frame
                    });
                return ;
              }
          
        }
      });
  return foundParents;
}

function proveWithoutJustification(tree, expr) {
  var node = MM_proof_tree.ptGetNode(tree, expr);
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    var parents = findAsrtParentsWithNewVars(tree, expr, MM_proof_tree.ptGetRootStmts(tree).map(function (stmt) {
              return stmt.expr;
            }), false, undefined, false, false, false, undefined, undefined, undefined, undefined);
    Expln_utils_common.arrForEach(parents, (function (parent) {
            MM_proof_tree.pnAddParent(node, parent, true);
            return MM_proof_tree.pnGetProof(node);
          }));
  }
  return node;
}

function getStatementsFromJustification(tree, jstf) {
  var getStmtByLabel = function (label) {
    var stmt = MM_proof_tree.ptGetRootStmts(tree).find(function (stmt) {
          return stmt.label === label;
        });
    if (stmt !== undefined) {
      return stmt.expr;
    }
    var hyp = MM_proof_tree.ptGetHypByLabel(tree, label);
    if (hyp !== undefined) {
      return hyp.expr;
    }
    
  };
  var foundStmts = jstf.args.map(getStmtByLabel).filter(Belt_Option.isSome).map(Belt_Option.getExn);
  if (foundStmts.length === jstf.args.length) {
    return foundStmts;
  }
  
}

function proveWithJustification(tree, expr, jstf) {
  var findAsrtParentsWithNewVars$1 = function (args, debugLevel) {
    return findAsrtParentsWithNewVars(tree, expr, args, true, jstf.label, false, false, false, debugLevel, undefined, undefined, undefined);
  };
  var node = MM_proof_tree.ptGetNode(tree, expr);
  if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
    var args = getStatementsFromJustification(tree, jstf);
    if (args !== undefined) {
      Expln_utils_common.arrForEach(findAsrtParentsWithNewVars$1(args, 0), (function (parent) {
              MM_proof_tree.pnAddParent(node, parent, true);
              return MM_proof_tree.pnGetProof(node);
            }));
      if (Belt_Option.isNone(MM_proof_tree.pnGetProof(node))) {
        Expln_utils_common.arrForEach(findAsrtParentsWithNewVars$1(args, 2), (function (parent) {
                MM_proof_tree.pnAddParent(node, parent, true);
                return MM_proof_tree.pnGetProof(node);
              }));
      }
      
    }
    
  }
  return node;
}

function srcIsBackRef(expr, src) {
  if (typeof src === "number" || src.TAG !== /* Assertion */1) {
    return false;
  } else {
    return src.args.some(function (arg) {
                return MM_context.exprEq(expr, MM_proof_tree.pnGetExpr(arg));
              });
  }
}

function proveBottomUp(tree, expr, getParents, maxSearchDepth, onProgress) {
  var nodesToCreateParentsFor = Belt_MutableQueue.make(undefined);
  var maxSearchDepthStr = String(maxSearchDepth);
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, (function (param) {
          
        }), undefined, undefined);
  MM_proof_tree.ptClearDists(tree);
  var rootNode = MM_proof_tree.ptGetNode(tree, expr);
  MM_proof_tree.pnSetDist(rootNode, 0);
  Belt_MutableQueue.add(nodesToCreateParentsFor, rootNode);
  var lastDist = 0;
  var maxCnt = 1;
  var cnt = 0;
  var onProgressP = Belt_Option.map(onProgress, (function (onProgress, numOfParents) {
          Curry._1(onProgress, "Proving bottom-up: 0/" + maxSearchDepthStr + " " + String(numOfParents) + "");
        }));
  while(Belt_Option.isNone(MM_proof_tree.pnGetProof(rootNode)) && !Belt_MutableQueue.isEmpty(nodesToCreateParentsFor)) {
    var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToCreateParentsFor));
    if (Belt_Option.isNone(MM_proof_tree.pnGetProof(curNode))) {
      var dist = MM_proof_tree.pnGetDist(curNode);
      var curDist;
      if (dist !== undefined) {
        curDist = dist;
      } else {
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Encountered a node without dist."
              },
              Error: new Error()
            };
      }
      if (onProgress !== undefined) {
        if (lastDist !== curDist) {
          onProgressP = undefined;
          lastDist = curDist;
          var curDistStr = String(curDist);
          progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, (function(curDistStr){
              return function (pct) {
                var pctStr = String(Math.round(pct * 100) | 0);
                Curry._1(onProgress, "Proving bottom-up: " + curDistStr + "/" + maxSearchDepthStr + " " + pctStr + "%");
              }
              }(curDistStr)), undefined, undefined);
          maxCnt = Belt_MutableQueue.size(nodesToCreateParentsFor) + 1 | 0;
          cnt = 0;
        }
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, cnt / maxCnt);
        cnt = cnt + 1 | 0;
      }
      var curExpr = MM_proof_tree.pnGetExpr(curNode);
      var parent = findNonAsrtParent(tree, curExpr);
      if (parent !== undefined) {
        MM_proof_tree.pnAddParent(curNode, parent, true);
      } else {
        var newDist = curDist + 1 | 0;
        if (newDist <= maxSearchDepth) {
          Curry._3(getParents, curExpr, curDist, onProgressP).forEach((function(curNode,curExpr,newDist){
              return function (src) {
                if (srcIsBackRef(curExpr, src)) {
                  return ;
                }
                MM_proof_tree.pnAddParent(curNode, src, true);
                if (typeof src === "number") {
                  return ;
                }
                if (src.TAG !== /* Assertion */1) {
                  return ;
                }
                src.args.forEach(function (arg) {
                      if (Belt_Option.isNone(MM_proof_tree.pnGetProof(arg)) && Belt_Option.isNone(MM_proof_tree.pnGetDist(arg))) {
                        MM_proof_tree.pnSetDist(arg, newDist);
                        return Belt_MutableQueue.add(nodesToCreateParentsFor, arg);
                      }
                      
                    });
              }
              }(curNode,curExpr,newDist)));
        }
        
      }
    }
    
  };
}

function proveStmtBottomUp(tree, expr, params, debugLevel, onProgress) {
  var getParents = function (expr, dist, onProgress) {
    var parents = findAsrtParentsWithNewVars(tree, expr, dist === 0 ? params.args0 : params.args1, false, dist === 0 ? params.asrtLabel : undefined, params.allowNewStmts, dist === 0 && params.allowNewVars, params.allowNewDisjForExistingVars, debugLevel, params.maxNumberOfBranches, onProgress, undefined);
    if (dist === 0) {
      return parents;
    }
    var exprLen = expr.length;
    return parents.filter(function (parent) {
                if (typeof parent === "number") {
                  return true;
                }
                if (parent.TAG !== /* Assertion */1) {
                  return true;
                }
                var frame = parent.frame;
                var args = parent.args;
                var argsAreCorrect = true;
                var numOfArgs = frame.hyps.length;
                var maxArgIdx = numOfArgs - 1 | 0;
                var argIdx = 0;
                while(argIdx <= maxArgIdx && argsAreCorrect) {
                  var arg = Caml_array.get(args, argIdx);
                  if (Caml_array.get(frame.hyps, argIdx).typ === /* E */1) {
                    var match = params.lengthRestrict;
                    var tmp;
                    switch (match) {
                      case /* No */0 :
                          tmp = true;
                          break;
                      case /* LessEq */1 :
                          tmp = MM_proof_tree.pnGetExpr(arg).length <= exprLen;
                          break;
                      case /* Less */2 :
                          tmp = MM_proof_tree.pnGetExpr(arg).length < exprLen;
                          break;
                      
                    }
                    argsAreCorrect = tmp;
                  }
                  argIdx = argIdx + 1 | 0;
                };
                return argsAreCorrect;
              });
  };
  proveBottomUp(tree, expr, getParents, params.maxSearchDepth, onProgress);
  return MM_proof_tree.ptGetNode(tree, expr);
}

function proveStmt(tree, expr, jstf, bottomUpProverParams, debugLevel, onProgress) {
  if (bottomUpProverParams !== undefined) {
    proveStmtBottomUp(tree, expr, bottomUpProverParams, debugLevel, onProgress);
  } else if (jstf !== undefined) {
    proveWithJustification(tree, expr, jstf);
  } else {
    proveWithoutJustification(tree, expr);
  }
}

function makeExprToStr(ctx, ctxMaxVar) {
  if (!MM_context.isDebug(ctx)) {
    return ;
  }
  var intToSym = function (i) {
    if (i <= ctxMaxVar) {
      return MM_context.ctxIntToSymExn(ctx, i);
    } else {
      return "&" + String(i);
    }
  };
  return (function (expr) {
            return expr.map(intToSym).join(" ");
          });
}

function createProofTree(proofCtx, frms, parenCnt) {
  var ctxMaxVar = MM_context.getNumOfVars(proofCtx) - 1 | 0;
  var hyps = MM_context.getAllHyps(proofCtx);
  var tree = MM_proof_tree.ptMake(frms, hyps, ctxMaxVar, MM_context.getAllDisj(proofCtx), parenCnt, makeExprToStr(proofCtx, ctxMaxVar));
  Belt_MapString.forEach(hyps, (function (label, hyp) {
          if (hyp.typ !== /* E */1) {
            return ;
          }
          var node = MM_proof_tree.ptGetNode(tree, hyp.expr);
          MM_proof_tree.pnAddParent(node, {
                TAG: /* Hypothesis */0,
                label: label
              }, true);
          MM_proof_tree.ptAddRootStmt(tree, {
                isHyp: true,
                label: label,
                expr: hyp.expr,
                jstf: undefined
              });
        }));
  return tree;
}

function proveFloatings(wrkCtx, frms, floatingsToProve, parenCnt) {
  var tree = createProofTree(wrkCtx, frms, parenCnt);
  floatingsToProve.forEach(function (expr) {
        proveFloating(tree, MM_proof_tree.ptGetNode(tree, expr));
      });
  return tree;
}

function proveSyntaxTypes(proofTree, wrkCtx, frms, parenCnt, exprs, syntaxTypes, onProgress, param) {
  if (Belt_Option.isNone(proofTree) && (Belt_Option.isNone(wrkCtx) || Belt_Option.isNone(frms) || Belt_Option.isNone(parenCnt))) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Either proofTree or (wrkCtx and frms and parenCnt) should be passed."
          },
          Error: new Error()
        };
  }
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined);
  var tree = proofTree !== undefined ? Caml_option.valFromOption(proofTree) : createProofTree(Belt_Option.getExn(wrkCtx), Belt_Option.getExn(frms), Belt_Option.getExn(parenCnt));
  if (syntaxTypes.length === 0) {
    return tree;
  }
  var lastType = Caml_array.get(syntaxTypes, 0);
  for(var ei = 0 ,ei_finish = exprs.length; ei < ei_finish; ++ei){
    var expr = Caml_array.get(exprs, ei);
    var node = MM_proof_tree.ptGetNode(tree, [lastType].concat(expr));
    proveFloating(tree, node);
    var ti = 0;
    while(Belt_Option.isNone(MM_proof_tree.pnGetProof(node)) && ti < syntaxTypes.length) {
      var typ = Caml_array.get(syntaxTypes, ti);
      ti = ti + 1 | 0;
      if (typ !== lastType) {
        node = MM_proof_tree.ptGetNode(tree, [typ].concat(expr));
        proveFloating(tree, node);
      }
      
    };
    var match = MM_proof_tree.pnGetProof(node);
    if (match !== undefined) {
      MM_proof_tree.ptAddSyntaxProof(tree, expr, node);
      lastType = Caml_array.get(MM_proof_tree.pnGetExpr(node), 0);
    }
    MM_progress_tracker.progressTrackerSetCurrPct(progressState, (ei + 1 | 0) / exprs.length);
  }
  return tree;
}

function createProofCtx(wrkCtx, rootStmts) {
  var proofCtx = MM_context.createContext(Caml_option.some(wrkCtx), undefined, undefined);
  rootStmts.forEach(function (stmt) {
        if (stmt.isHyp) {
          return MM_context.applySingleStmt(proofCtx, {
                      TAG: /* Essential */6,
                      label: stmt.label,
                      expr: MM_context.ctxIntsToSymsExn(wrkCtx, stmt.expr)
                    });
        }
        
      });
  return proofCtx;
}

function unifyAll(wrkCtx, frms, rootStmts, parenCnt, bottomUpProverParams, syntaxTypes, exprsToSyntaxCheck, debugLevelOpt, onProgress, param) {
  var debugLevel = debugLevelOpt !== undefined ? debugLevelOpt : 0;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, Belt_Option.map(onProgress, (function (onProgress, pct) {
              Curry._1(onProgress, "Unifying all: " + Common.floatToPctStr(pct) + "");
            })), undefined, undefined);
  var proofCtx = createProofCtx(wrkCtx, rootStmts);
  var tree = createProofTree(proofCtx, frms, parenCnt);
  if (syntaxTypes !== undefined && syntaxTypes.length > 0 && exprsToSyntaxCheck !== undefined) {
    proveSyntaxTypes(Caml_option.some(tree), undefined, undefined, undefined, exprsToSyntaxCheck, syntaxTypes, Belt_Option.map(onProgress, (function (onProgress, pct) {
                Curry._1(onProgress, "Checking syntax: " + Common.floatToPctStr(pct) + "");
              })), undefined);
  }
  var rootProvables = rootStmts.filter(function (stmt) {
        return !stmt.isHyp;
      });
  var numOfStmts = rootProvables.length;
  var maxStmtIdx = numOfStmts - 1 | 0;
  rootProvables.forEach(function (stmt, stmtIdx) {
        proveStmt(tree, stmt.expr, stmt.jstf, stmtIdx === maxStmtIdx ? bottomUpProverParams : undefined, debugLevel, stmtIdx !== maxStmtIdx || Belt_Option.isNone(bottomUpProverParams) ? undefined : onProgress);
        MM_proof_tree.ptAddRootStmt(tree, stmt);
        MM_progress_tracker.progressTrackerSetCurrPct(progressState, (stmtIdx + 1 | 0) / numOfStmts);
      });
  return tree;
}

exports.bottomUpProverParamsMake = bottomUpProverParamsMake;
exports.createProofCtx = createProofCtx;
exports.proveFloatings = proveFloatings;
exports.proveSyntaxTypes = proveSyntaxTypes;
exports.unifyAll = unifyAll;
/* Common Not a pure module */
